'use client';
import React from 'react';
import Link from 'next/link';
import { EdgeBadge } from '@benzinga/core-ui';
import { ShareButtons } from '@benzinga/ui';
import styles from './StandardHero.module.scss';
import { GovTradesTabs } from './GovTradesTabs';
import { GOV_TRADES_TAB_DESCRIPTIONS, type GovTradesTab } from './getActiveGovTradesTab';
import { BreadcrumbSchema } from '../BreadcrumbSchema';

const INTRO =
  'Track stock trades filed by US lawmakers under the STOCK Act. Spot high-performing trades, monitor portfolio returns, and search by ticker, politician, or chamber.';

export const StandardHero = ({
  activeTab,
  search,
  url,
  showShare = true,
}: {
  activeTab: GovTradesTab | null;
  search: React.ReactNode;
  url: string;
  showShare?: boolean;
}) => (
  <section className={styles['hero']} data-testid="gov-trades-hero">
    <BreadcrumbSchema
      items={[
        { name: 'Tools', url: '/tools' },
        { name: 'Government Trades', url: '/government-trades' },
        ...(activeTab && activeTab !== 'Overview'
          ? [{ name: activeTab, url: `/government-trades/${activeTab.toLowerCase()}` }]
          : []),
      ]}
    />
    <div className={styles['wrap']}>
      <nav className={styles['crumb']} aria-label="Breadcrumb">
        <Link href="/tools">Tools</Link> /{' '}
        {activeTab && activeTab !== 'Overview' ? (
          <>
            <Link href="/government-trades">Government Trades</Link> / {activeTab}
          </>
        ) : (
          'Government Trades'
        )}
      </nav>
      <div className={styles['top']}>
        <h1 className={styles['title']}>
          Government Trades <span className={styles['badge']}>{EdgeBadge}</span>
        </h1>
        {showShare ? (
          <ShareButtons
            buttonLocation="gov-trades-hero"
            title="Government Trades"
            url={url}
            showButtons={['linkedin', 'twitter', 'facebook', 'email', 'copy']}
            buttonStyle={{ round: true, size: 32, bgStyle: { fill: 'rgba(255, 255, 255, 0.08)' }, iconFillColor: '#9aa9bf' }}
          />
        ) : null}
      </div>
      <div className={styles['row2']}>
        <p className={styles['sub']}>{activeTab ? GOV_TRADES_TAB_DESCRIPTIONS[activeTab] : INTRO}</p>
      </div>
      <div className={styles['searchRow']}>
        {search ? <div className={styles['search']}>{search}</div> : null}
        <GovTradesTabs activeTab={activeTab} />
      </div>
    </div>
  </section>
);
